import React from "react";
import Navbar from "../../Navbar/Navbar";
import ModelOrders from "./ModelOrders";
import FillDetailOrders from "./FillDetailOrders";
import ScroollTableOrders from "./ScroollTableOrders";
import { ProductConsumer } from "../../Context/AddProWakel";
import "../shared/rtl-panel.css";

class AllOrdersPage extends React.Component {
    render() {
        return (
            <div>
                <Navbar />
                <ProductConsumer>
                    {(value) => <OrdersBody value={value} />}
                </ProductConsumer>
                <ModelOrders />
            </div>
        );
    }
}

class OrdersBody extends React.Component {
    componentDidMount() {
        this.props.value.OR_getOrders();
    }

    render() {
        return (
            <div className="rs-page" dir="rtl">
                <FillDetailOrders />
                <ScroollTableOrders />
            </div>
        );
    }
}

export default AllOrdersPage;
